import SafeAreaPage from './SafeAreaPage';

export type { Props as SafeAreaPageProps } from './SafeAreaPage';
export default SafeAreaPage;
